import axios from "axios";
import React, { useState, useRef } from "react";
import { useToast, Text ,Button} from "@chakra-ui/react";
import ReactLoading from "react-loading";
import imageCompression from 'browser-image-compression';
import Compressor from 'compressorjs';
import API_URL from "../Api/auction-api";


const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneno, setPhoneno] = useState(0);
  const [productcategory, setProductCategory] = useState("");
  const [productname, setproductName] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [userCountry, setUserCountry] = useState("");
  const [productimage, setProductImage] = useState("");
  const [initialBid, setInitialBid] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [network, setNetwork] = useState("");
  const [address, setAddress] = useState("");
  const [Polygonaddress, setPolygonaddress] = useState("");
  const [paypalEmail, setPaypalEmail] = useState("");
  const [description, setDescription] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [showCustomCategory, setShowCustomCategory] = useState(false);
  const [selectCategory, setSelectCategory] = useState("");
  const [productType, setproductType] = useState("");
  const [isloading, setLoading] = useState(false);
  const formRef = useRef();

  const toast = useToast();
  //  onchange function
  const handlePaymentMethodChange = (event) => {
    setPaymentMethod(event.target.value);
  };

   //  onchange function
  const handleNetworkChange = (event) => {
    setNetwork(event.target.value);
  };

   //  onchange function
  const handleAddressChange = (event) => {
    setAddress(event.target.value);
  };
   //  onchange function
  const handlePaypalEmailChange = (event) => {
    setPaypalEmail(event.target.value);
  };

   //  onchange function
  const handlePolygonAddressChange = (event) => {
    setPolygonaddress(event.target.value);
  };

  // const handleImageUpload = (event) => {
  //   const file = event.target.files[0];
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     console.log(reader.result);
  //     setSelectedImage(reader.result);
  //   };
  //   reader.readAsDataURL(file);
  // };

  function sizeReduce(file){


    

  }


  
  //   const file = event.target.files[0];
  
  //   try {
  //     const compressedImage = await compressImage(file);
  //     setSelectedImage(compressedImage);
  //   } catch (error) {
  //     console.error('Error compressing image:', error);
  //   }
  // };
  
  // const compressImage = async (imageFile) => {
  //   const options = {
  //     maxSizeMB: 1, // Adjust the maximum file size as per your requirements
  //     maxWidthOrHeight: 800, // Adjust the maximum width or height as per your requirements
  //     useWebWorker: true, // Enable web worker for faster compression (optional)
  //   };
  
  //   try {
  //     const compressedFile = await imageCompression(imageFile, options);
  //     const compressedImage = await convertFileToBase64(compressedFile);
  //     return compressedImage;
  //   } catch (error) {
  //     console.error('Error compressing image:', error);
  //     throw error;
  //   }
  // };
  
  // const convertFileToBase64 = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       resolve(reader.result);
  //     };
  //     reader.onerror = reject;
  //     reader.readAsDataURL(file);
  //   });

  //  //  onchange function and reduce image size
  const handleImageUpload = async (e) => {
  console.log(e.target.files[0],"file[0]")

  const file = e.target.files[0];
  if (!file) {
    return;
  }
  // new Compressor(file, {
  //   quality: 0.2,
  //   success(result) {
  //     // First compression
  //     new Compressor(result, {
  //       quality: 0.2,
  //       success(result2) {
  //         const reader = new FileReader();
  //         reader.readAsDataURL(result2);
  //         reader.onloadend = () => {
  //           // Use the compressed image
  //           const selectedImage = reader.result;
  //           console.log(selectedImage);
            
  //           // Send the compressed image file to the server with XMLHttpRequest.
  //           // axios.post('/path/to/upload', formData).then(() => {
  //           //   console.log('Upload success');
  //           // });
  //         };
  //       },
  //       error(err2) {
  //         console.log(err2.message);
  //       },
  //     });
  //   },
  //   error(err) {
  //     console.log(err.message);
  //   },
  // });
  


  new Compressor(file, {
    quality: 0.5,
    maxHeight:900,
    maxWidth:900,

    

    // The compression process is asynchronous,
    // which means you have to access the `result` in the `success` hook function.
    success(result) {
      const reader = new FileReader();
        reader.readAsDataURL(result);
        console.log(result,"result")
             reader.onloadend = () => {
          console.log(reader.result,"jdkdkdjd")
          setSelectedImage(reader.result);
          console.log(selectedImage);
        
             }
        
       

      // Send the compressed image file to server with XMLHttpRequest.
      // axios.post('/path/to/upload', formData).then(() => {
      //   console.log('Upload success');
      // });
    },
    error(err) {
      console.log(err.message);
    },
  });



  };


  const handleRegister = async () => {
    const payload = {
      name,
      email,
      phoneno,
      productcategory,
      producttype: productType,
      productname,
      address: userAddress,
      country: userCountry,
      productimage: selectedImage,
      productinitialrate: initialBid,
      paymentmethode: paymentMethod,
      blockchainnetwork: network,
      blockchainaddress: address,
      polygonnetwork: Polygonaddress,
      description,
      status: false,
    };

    try {
      
      if (name && email && phoneno && productcategory && productType && productname && userAddress && userCountry && selectedImage && initialBid && paymentMethod && description ) {
        
        setLoading(true)
        let res = await axios.post(`${API_URL}/auctionuserregister`,payload);
       
        setLoading(false)
        toast({
          title: "Your Details is sended to the Admin",
          description: "Please wait admin approve your request ",
          status: "success",
          duration: 9000,
          isClosable: true,
          position: "top-right",
        });
        formRef.current.reset();
        setPaypalEmail("");
        setPaymentMethod("");
        setNetwork("");
        setAddress("");
        setPolygonaddress("")
        
        // document.getElementById("form").reload()
        console.log(res, "res");
      } else {
        toast({
          title: "Please fill all the details",
          description:"Required All the Details please fill..",
          status: "error",
          duration: 9000,
          isClosable: true,
          position: "top-right",
        });
      }
    } catch (error) {
      toast({
        title: "Error while Register",
        description:"Please Register Your Details sometimes later",
        status: "error",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
      console.log(error);
    }
  };

  return (
    <>
      <div>
      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
        <h1
          className="flex flex-col justify-start items-start text-3xl font-bold mb-10 ml-5"
          data-aos="fade-down"
          data-aos-delay="300"
          data-aos-once="true"
        >
          Steps for Participate in Auction
        </h1>
        <div className="grid gap-6 row-gap-10 lg:grid-cols-2">
          <div className="lg:py-6 lg:pr-16">
            <div data-aos="fade-down" data-aos-delay="300" data-aos-once="true">
              <div className="flex">
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-4 text-gray-600"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <line
                          fill="none"
                          strokeMiterlimit="10"
                          x1="12"
                          y1="2"
                          x2="12"
                          y2="22"
                        />
                        <polyline
                          fill="none"
                          strokeMiterlimit="10"
                          points="19,15 12,22 5,15"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="w-px h-full bg-gray-300" />
                </div>
                <div className="pt-1 pb-8">
                  <p className="mb-2 text-lg font-bold">Step 1</p>
                  <p className="text-gray-700">
                    Enter your full name, email address, and phone number in the
                    provided fields. Select the appropriate product category,
                    such as "Home and Kitchen," or choose "Other" if your
                    category is not listed and manually enter it. Specify the
                    product type, such as "Bowl," and provide the name of the
                    product, such as "Antique and Rare Bowl."
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-4 text-gray-600"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <line
                          fill="none"
                          strokeMiterlimit="10"
                          x1="12"
                          y1="2"
                          x2="12"
                          y2="22"
                        />
                        <polyline
                          fill="none"
                          strokeMiterlimit="10"
                          points="19,15 12,22 5,15"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="w-px h-full bg-gray-300" />
                </div>
                <div className="pt-1 pb-8">
                  <p className="mb-2 text-lg font-bold">Step 2</p>
                  <p className="text-gray-700">
                    Enter your home address, as we will utilize this information
                    for product pick-up purposes. Enter your country Name. Next,
                    add a clear image of the product you are auctioning. This
                    image will be displayed on the product card for potential
                    bidders to see. Additionally, set the initial bid for your
                    product, determining the starting value for bidding
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-4 text-gray-600"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <line
                          fill="none"
                          strokeMiterlimit="10"
                          x1="12"
                          y1="2"
                          x2="12"
                          y2="22"
                        />
                        <polyline
                          fill="none"
                          strokeMiterlimit="10"
                          points="19,15 12,22 5,15"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="w-px h-full bg-gray-300" />
                </div>
                <div className="pt-1 pb-8">
                  <p className="mb-2 text-lg font-bold">Step 3</p>
                  <p className="text-gray-700">
                    Then choose your preferred payment mode. If you select Malak
                    Token, please ensure that you enter the correct Polygon
                    network account address. If you choose USDT, please enter
                    the correct network, such as Ethereum, and provide the
                    corresponding account address. By carefully completing these
                    steps, you can successfully register for the auction
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-4 text-gray-600"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <line
                          fill="none"
                          strokeMiterlimit="10"
                          x1="12"
                          y1="2"
                          x2="12"
                          y2="22"
                        />
                        <polyline
                          fill="none"
                          strokeMiterlimit="10"
                          points="19,15 12,22 5,15"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="w-px h-full bg-gray-300" />
                </div>
                <div className="pt-1 pb-8">
                  <p className="mb-2 text-lg font-bold">Step 4</p>
                  <p className="text-gray-700">
                    Enter the unique details or description of your product in
                    the provided description box. After providing the necessary
                    information, click on the register button. Your product
                    information will be forwarded to our admin for approval.
                    Once your product is approved, you will be able to see it in
                    the "Participate in Auction" section. If your product is
                    successfully sold during the auction, we will arrange for
                    the product to be picked up and provide you with the payment
                    for the sale.
                  </p>
                </div>
              </div>
              <div className="flex">
                <div className="flex flex-col items-center mr-4">
                  <div>
                    <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                      <svg
                        className="w-6 text-gray-600"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <polyline
                          fill="none"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit="10"
                          points="6,12 10,16 18,8"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="pt-1">
                  <p className="mb-2 text-lg font-bold">Done</p>
                  <p className="text-gray-700" />
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <form
              action=""
              className="space-y-4"
              onSubmit={(e) => e.preventDefault()}
              id="form"
              ref={formRef}
            >
              <div>
                <label className="sr-only" htmlFor="name">
                  Full Name
                </label>
                <input
                  className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                  placeholder="Full Name"
                  type="text"
                  id="Full name"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 ">
                <div>
                  <label className="sr-only" htmlFor="email">
                    Email
                  </label>
                  <input
                    className="w-full rounded-lg p-3 text-sm border border-gray-500"
                    placeholder="Email address"
                    type="email"
                    id="email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div>
                  <label className="sr-only" htmlFor="phone">
                    Phone
                  </label>
                  <input
                    className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                    placeholder="Phone Number"
                    type="tel"
                    id="phone"
                    onChange={(e) => setPhoneno(e.target.value)}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                  <label className="sr-only" htmlFor="product-category">
                    Product Category
                  </label>
                  <select
                    className="w-full rounded-lg p-3 text-sm border border-gray-500"
                    id="product-category"
                    onChange={(e) => {
                      if (e.target.value === "Other") {
                        setShowCustomCategory(true);
                      } else {
                        setProductCategory(e.target.value);
                        setShowCustomCategory(false);
                      }
                    }}
                  >
                    <option value="">Select Product Category</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Fashion and Apparel">
                      Fashion and Apparel
                    </option>
                    <option value="Home and Kitchen">Home and Kitchen</option>
                    <option value="Beauty and Personal Care">
                      Beauty and Personal Care
                    </option>
                    <option value="Books and Media">Books and Media</option>
                    <option value="Sports and Fitness">
                      Sports and Fitness
                    </option>
                    <option value="Toys and Games">Toys and Games</option>
                    <option value="Health and Wellness">
                      Health and Wellness
                    </option>
                    <option value="Automotive and Accessories">
                      Automotive and Accessories
                    </option>
                    <option value="Baby and Maternity">
                      Baby and Maternity
                    </option>
                    <option value="Furniture and Home Decor">
                      Furniture and Home Decor
                    </option>
                    <option value="Jewelry and Watches">
                      Jewelry and Watches
                    </option>
                    <option value="Pet Supplies">Pet Supplies</option>
                    <option value="Tools and Home Improvement">
                      Tools and Home Improvement
                    </option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                {showCustomCategory && (
                  <div>
                    <label className="sr-only" htmlFor="custom-category">
                      Custom Category
                    </label>
                    <input
                      className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                      placeholder="Enter Custom Category"
                      type="text"
                      id="custom-category"
                      onChange={(e) => setProductCategory(e.target.value)}
                    />
                  </div>
                )}
                <div>
                  <label className="sr-only" htmlFor="product-Type">
                    Product Type
                  </label>
                  <input
                    className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                    placeholder="Product Type"
                    type="text"
                    id="product-Type"
                    onChange={(e) => setproductType(e.target.value).toLowerCase()}
                  />
                </div>
              </div>
              <div>
                <label className="sr-only" htmlFor="Product Name">
                  Product Name
                </label>
                <input
                  className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                  placeholder="Product Name"
                  type="text"
                  id="Product Name"
                  onChange={(e) => setproductName(e.target.value.toLowerCase())}
                />
              </div>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 ">
                <div>
                  <label className="sr-only" htmlFor="email">
                    Address
                  </label>
                  <input
                    className="w-full rounded-lg p-3 text-sm border border-gray-500"
                    placeholder="Address"
                    type="text"
                    id=""
                    onChange={(e) => setUserAddress(e.target.value)}
                  />
                </div>

                <div>
                  <label className="sr-only">Country</label>
                  <input
                    className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                    placeholder="Country"
                    type="text"
                    id=""
                    onChange={(e) => setUserCountry(e.target.value)}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 ">
                <div>
                  <label className="">Product Image</label>
                  <input
                    className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                    placeholder="Discription About Product"
                    type="file"
                    id=""
                    accept="image/*"
                    onChange={handleImageUpload}
                    // onChange={(e) => setProductImage(e.target.value)}
                  ></input>
                </div>
                <div>
                  <label className="sr-only">Initial Bid</label>

                  <input
                    className="w-full rounded-lg border border-gray-500 p-3 text-sm lg:mt-6 md:mt-6"
                    placeholder="$ Initial Bid"
                    type="number"
                    id="number"
                    onChange={(e) => setInitialBid(e.target.value)}
                  ></input>
                </div>
              </div>
              <div>
                <label className="sr-only" htmlFor="paymentMethod">
                  Payment Method
                </label>
                <select
                  className="w-full rounded-lg p-3 text-sm border border-gray-500"
                  id="paymentMethod"
                  value={paymentMethod}
                  onChange={handlePaymentMethodChange}
                >
                  <option value="">Select Payment Method</option>
                  <option value="cryptoTransferMAAT">
                    Crypto Transfer (MAAT) Malak-Token
                  </option>
                  <option value="cryptoTransfer">Crypto Transfer (USDT)</option>
                  <option value="paypal">PayPal (Coming soon....)</option>
                </select>
              </div>
              {/* Additional fields for Crypto Transfer (USDT) */}
              {paymentMethod === "cryptoTransfer" && (
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                    <label className="sr-only" htmlFor="network">
                      Blockchain Network
                    </label>
                    <input
                      className="w-full rounded-lg p-3 text-sm border border-gray-500"
                      placeholder="Blockchain Network"
                      type="text"
                      id="Blockchain network"
                      value={network}
                      onChange={handleNetworkChange}
                    />
                  </div>
                  <div>
                    <label className="sr-only" htmlFor="address">
                      Address
                    </label>
                    <input
                      className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                      placeholder="Address"
                      type="text"
                      id="address"
                      value={address}
                      onChange={handleAddressChange}
                    />
                  </div>
                </div>
              )}
              {/* Additional fields for Crypto Transfer (MAAT) */}
              {paymentMethod === "cryptoTransferMAAT" && (
                <div>
                  <label className="sr-only" htmlFor="Polygonaddress">
                    Enter Polygon network Account Address
                  </label>
                  <input
                    className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                    placeholder="Enter Polygon Network Account Address"
                    type="text"
                    id="Polygonaddress"
                    value={Polygonaddress}
                    onChange={handlePolygonAddressChange}
                  />
                </div>
              )}
              {/* Additional fields for PayPal */}
              {paymentMethod === "paypal" && (
                <div>
                  <label className="sr-only" htmlFor="paypalEmail">
                    PayPal Email
                  </label>
                  <input
                    className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                    placeholder="Coming soon....."
                    type="email"
                    disabled
                    id="paypalEmail"
                    value={paypalEmail}
                    onChange={handlePaypalEmailChange}
                  />
                </div>
              )}
              <div>
                <label className="sr-only" htmlFor="message">
                  Discription About Product
                </label>

                <textarea
                  className="w-full rounded-lg border border-gray-500 p-3 text-sm"
                  placeholder="Discription About Product"
                  rows="6"
                  id="message"
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>

              <div className="mt-4">
              <Button
                isLoading={isloading}
                  type="submit"
                  className="inline-block w-full rounded-lg text-lg items-center justify-center h-12 px-6 font-medium tracking-wide text-white bg-blue-500 shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
                  onClick={handleRegister}
                  colorScheme='blue'
                >
                  Register
                </Button>
                
              </div>
            </form>
            
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Register;
